import { sameData } from '../../../utils/sameData';
import { sameDressStyleSelection } from '../../../utils/dressStyles';

// Helpers for the Settings page's Save buttons: a button is enabled only when what is on screen differs from the
// last saved copy, so these compare "staged" values with the saved ones in the way the form actually behaves.

// Starting state of the "additional instructions" toggles on the photo-edit tab.
export const DEFAULT_PROMPT_FLAGS = {
    removeGlasses: true, glowMakeup: true, showCustomInstruction: true,
    removeStrayHair: false, removeBeard: false, openEyes: false, closeMouth: true, keepSchoolDressDetails: false,
    removeTupi: false, straightenHead: false,
};

// Dress colour lists are sets: order doesn't matter, and null / [] both mean "everything enabled". (Dress STYLES are compared
// by what they switch on — see sameDressStyleSelection — because newer styles are on without being listed.)
const sameSet = (a, b) => {
    const x = a?.length ? a : null;
    const y = b?.length ? b : null;
    return x === null || y === null ? x === y : x.length === y.length && x.every((v) => y.includes(v));
};

// The prompt toggles are booleans: a key that is absent is "off".
const samePromptFlags = (a, b) => [...new Set([...Object.keys(a), ...Object.keys(b)])].every((k) => !!a[k] === !!b[k]);

/** Do two photo-edit snapshots (see SettingsPage `savedPhotoEdit`) hold the same settings? */
export function photoEditSame(a, b, country) {
    const { defaultPrompts: pa, enabledDressStyles: sa, enabledDressColors: ca, ...ra } = a;
    const { defaultPrompts: pb, enabledDressStyles: sb, enabledDressColors: cb, ...rb } = b;
    return samePromptFlags(pa, pb) && sameDressStyleSelection(sa, sb, country) && sameSet(ca, cb) && sameData(ra, rb);
}

/** A suggestion row reduced to what gets saved, so the on-screen list can be compared with the saved one. */
export const plainSuggestion = (s) => ({ name: s.name, price: s.price ?? null, category: s.category || null });
